module.exports = __webpack_public_path__ + "70abb99a3992f135ed5e10456a682fad.svg";